<script setup>
  import 'vue3-carousel/dist/carousel.css'  
  import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'
  import { useWebStore } from '@/store/web.js'
  const store = useWebStore();
  const props = defineProps(['slides','height','cardWidth'])
</script>
<template>
  <carousel v-if="slides.length!==0"
    class="h-full"
    :items-to-show="1"
    :wrap-around="true"
    :autoplay="5000"
    :transition="1000">
    <Slide class="h-56" v-for="(slide, index) in slides" :key="index" :style="{backgroundImage:'url(/'+slide.image+')', backgroundPosition:'center'}">
      <div class="w-full " :style="{height: height}">
        <div class="gradient-card w-11/12 h-11/12 m-auto text-white p-1 sm:w-3/4 md:w-2/3 md:ml-5 lg:p-4 xl:w-1/3  2xl:w-1/4">
          <h2 class="InterExtraBold text-2xl">{{slide.title}}</h2>
          <p class="InterMedium text-l mt-3">
            {{store.screenSize==='mobile'?slide.mobSubtitle===undefined?slide.subtitle:slide.mobSubtitle:slide.subtitle}}
          </p>
        </div>
      </div>
    </Slide>
  </carousel>
</template>

<style scoped lang="scss">

  .gradient-card {
    background: linear-gradient(to right, rgba(250, 64, 2, 0.8), rgba(250, 143, 2, 0.8), rgba(250, 143, 2, 0.8));
    border-radius: 10px;
  }
</style>